// src/components/BreadcrumbsNav.jsx
import React, { useEffect, useState } from 'react';
import { Breadcrumbs, Typography, Link as MuiLink } from '@mui/joy';
import { Link, useLocation } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const BreadcrumbsNav = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);
  const [resolvedLabels, setResolvedLabels] = useState({});

  useEffect(() => {
    const fetchLabels = async () => {
      const labels = {};

      for (const value of pathnames) {
        if (/^[0-9a-fA-F-]{36}$/.test(value)) {
          let { data, error } = await supabase.from('clients').select('name').eq('id', value).single();
          if (!error && data) {
            labels[value] = data.name;
            continue;
          }

          ({ data, error } = await supabase.from('projects').select('name').eq('id', value).single());
          if (!error && data) {
            labels[value] = data.name;
            continue;
          }

          ({ data, error } = await supabase.from('project_records').select('name').eq('id', value).single());
          if (!error && data) {
            labels[value] = data.name;
          }
        }
      }

      setResolvedLabels(labels);
    };

    fetchLabels();
  }, [location]);

  return (
    <Breadcrumbs size="sm" sx={{ mb: 2 }}>
      <MuiLink component={Link} to="/" underline="hover" color="neutral">
        Home
      </MuiLink>
      {pathnames.map((value, index) => {
        const to = '/' + pathnames.slice(0, index + 1).join('/');
        const isLast = index === pathnames.length - 1;

        const label = resolvedLabels[value] || decodeURIComponent(value)
          .replace(/-/g, ' ')
          .replace(/\b\w/g, c => c.toUpperCase());

        return isLast ? (
          <Typography key={to} color="primary">
            {label}
          </Typography>
        ) : (
          <MuiLink component={Link} to={to} key={to} underline="hover" color="neutral">
            {label}
          </MuiLink>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbsNav;